import api from "@services/newApi/api";
import type { IGetHospitalsResponse } from "./types";

export const getHospitals = async (signal: AbortSignal) => {
  const { data } = await api.get<{ data: { hospitals: IGetHospitalsResponse[] } }>("hospitals", { signal });
  return data.data.hospitals;
};
export const registerChangeHospitalLog = async (uuid: string) =>
  await api.post(`/logs/hospital-activity`, { hospitalUuid: uuid });
